export const faqData = [
  {
    question: '99漫画是什么？',
    answer: '99漫画是一个免费漫画推荐平台，致力于为用户推荐类似4399漫画网的同类型优质漫画资源。我们精心整理了韩漫、日漫、国漫等各类热门漫画，支持下拉式阅读，让您轻松追更收藏。',
  },
  {
    question: '99漫画和4399漫画网有什么不同？',
    answer: '99漫画与4399漫画网一样，都提供免费漫画阅读服务。99漫画在此基础上进一步优化了阅读体验，提供更流畅的下拉式阅读模式，更智能的漫画推荐算法，以及更全面的韩漫、日漫、国漫资源覆盖。',
  },
  {
    question: '如何在99漫画上阅读漫画？',
    answer: '访问99漫画平台后，您可以通过首页热门推荐、分类导航或搜索功能找到感兴趣的漫画。点击漫画进入详情页后，选择章节即可开始下拉式阅读。阅读过程中会自动保存进度，方便下次继续。',
  },
  {
    question: '99漫画支持哪些类型的漫画？',
    answer: '99漫画目前覆盖三大主要漫画类型：韩漫（韩国漫画）——画风精美，剧情丰富；日漫（日本漫画）——经典热血，类型多样；国漫（中国漫画）——崛起之作，品质优秀。每个类型下还有玄幻、恋爱、悬疑、搞笑等多种题材标签。',
  },
  {
    question: '99漫画是否完全免费？',
    answer: '是的，99漫画平台上推荐的所有漫画资源均为免费阅读。我们致力于打造一个开放、免费的漫画阅读社区，让每一位漫画爱好者都能无门槛享受阅读乐趣。',
  },
  {
    question: '什么是下拉式阅读？',
    answer: '下拉式阅读是一种专为移动端和网页端优化的阅读模式。不同于传统的翻页模式，您只需向下滑动页面即可连续阅读漫画内容，阅读体验更加流畅自然。99漫画推荐的漫画平台普遍支持这一阅读模式。',
  },
  {
    question: '如何收藏和追更漫画？',
    answer: '在您喜欢的漫画详情页，可以点击收藏按钮将漫画加入您的收藏夹。当漫画有更新时，您可以在个人收藏中第一时间看到更新提醒，确保不错过任何精彩章节。',
  },
  {
    question: '99漫画平台稳定性如何？',
    answer: '99漫画推荐的所有漫画平台均经过严格筛选，确保访问稳定、加载快速。我们持续监控各平台的运行状态，如发现异常会及时更新推荐，保障用户的最佳阅读体验。',
  },
];